<div class="invitation-expired-container">
  <div class="invitation-expired-content">
    <div class="icon-container">
      <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
    </div>
    
    <h1 class="title">{{ 'InvitationExpired.Title' | translate }}</h1>
    <p class="message">{{ 'InvitationExpired.Message' | translate }}</p>
    
    <!-- <div class="actions">
      <button class="btn btn-primary" (click)="goHome()">
        {{ 'InvitationExpired.GoHome' | translate }}
      </button>
    </div> -->
  </div>
</div>
